
console.log("Smartsettle start")
import { createApp, h } from 'vue';
import store from "store/index";
//import { createPinia } from 'pinia';
import Quadro from 'quadro'
import MyI18n from 'plugins/my_i18n'
import { createI18n } from 'vue-i18n/dist/vue-i18n.esm-bundler.js';
const i18n = createI18n({
  locale: 'en', // default locale
  fallbackLocale: 'en', // fallback locale
  globalInjection: true, // Allows using $t in templates without explicit import
});
//const pinia = createPinia();
export default class SmartsettlePanel {
  constructor(elementId, apiEndpoint, caseId, ...args) {
    let credentials
    let options
    console.log("Smartsettle constructor")
    if (args[0] && args[1]) {
      credentials = {username: args[0], apiKey: args[1]}
      options = args[3]
    } else {
      options = args[0]
    }
    if (options?.locale) {
      i18n.locale = options.locale
    }

    this.parent = createApp({
      el: elementId,
      data(){ return {options}; },
      render: () => h(Quadro, {apiEndpoint: apiEndpoint, caseId: caseId, credentials: credentials})
    })
    this.parent.config.productionTip = false
    //this.parent.use(pinia)
    console.log("smartsettle_panel - store")
    console.log(store)
    this.parent.use(store)
    this.parent.use(MyI18n)
    this.parent.mount(elementId)
  }
}

//export default SmartsettlePanel
